import { render, staticRenderFns } from "./element.vue?vue&type=template&id=a1ce2f9c&scoped=true&"
import script from "./element.vue?vue&type=script&lang=js&"
export * from "./element.vue?vue&type=script&lang=js&"
import style0 from "./element.vue?vue&type=style&index=0&id=a1ce2f9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ce2f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1ce2f9c')) {
      api.createRecord('a1ce2f9c', component.options)
    } else {
      api.reload('a1ce2f9c', component.options)
    }
    module.hot.accept("./element.vue?vue&type=template&id=a1ce2f9c&scoped=true&", function () {
      api.rerender('a1ce2f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/compose/element.vue"
export default component.exports